import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { map, Observable } from 'rxjs';

import { PhoneValidatorHttpService } from './phone-validator.httpservice';

@Injectable({ providedIn: 'root' })
export class PhoneAsyncValidator implements AsyncValidator {
  constructor(private phoneValidatorHttp: PhoneValidatorHttpService) {}

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    return this.phoneValidatorHttp.getIsPhoneNumberValid(control.value).pipe(
      map((isValid) => (isValid ? null : { invalidPhoneNumber: true }))
    );
  }
}
